import { render, staticRenderFns } from "./TrimmingImage.vue?vue&type=template&id=4de775a6&scoped=true&"
import script from "./TrimmingImage.vue?vue&type=script&lang=js&"
export * from "./TrimmingImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de775a6",
  null
  
)

export default component.exports